<template>
  <div>
    <!-- Selected required forms as list (similar to line items) -->
    <q-list v-if="modelValue && modelValue.length > 0" separator>
      <q-item-wrapper
        v-for="form in selectedForms"
        :key="form.id"
      >
        <div class="row items-center">
          <div class="col">
            <q-item-label class="text-bold">
              {{ form.title }}
              <span v-if="form.master_version != null" class="text-caption text-grey q-ml-xs">(v{{ form.master_version }}.{{ form.minor_version || 0 }})</span>
            </q-item-label>
            <q-item-label v-if="form.category" caption>
              {{ form.category }}
            </q-item-label>
          </div>
        </div>

        <template #after>
          <q-item-section side @click.stop>
            <cancel-button
              flat
              @click="removeForm(form.id)"
            />
          </q-item-section>
        </template>
      </q-item-wrapper>
    </q-list>
    <div v-else class="text-caption text-grey q-px-md q-py-sm">
      No required report templates selected
    </div>

    <!-- Add form button (similar to clickable-item) -->
    <clickable-item
      label="Add required form..."
      @click="openSelector"
    />

    <!-- Form selector dialog -->
    <SelectFormDialog
      ref="selectFormDialog"
      @selected="onFormSelected"
    />
  </div>
</template>

<script>
import SelectFormDialog from 'components/app/forms/partials/SelectFormDialog.vue'

export default {
  components: {
    SelectFormDialog
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    requiredFormTemplates: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'form-added', 'form-removed'],
  computed: {
    selectedForms () {
      // Use requiredFormTemplates if available (from API), otherwise use empty array
      return this.requiredFormTemplates || []
    }
  },
  methods: {
    openSelector () {
      this.$refs.selectFormDialog.open()
    },
    onFormSelected (form) {
      const currentIds = this.modelValue || []
      // Don't add duplicates
      if (!currentIds.includes(form.id)) {
        this.$emit('update:modelValue', [...currentIds, form.id])
        // Also update the form templates for display
        this.$emit('form-added', form)
      }
    },
    removeForm (formId) {
      const currentIds = this.modelValue || []
      this.$emit('update:modelValue', currentIds.filter(id => id !== formId))
      this.$emit('form-removed', formId)
    }
  }
}
</script>
